import Login from "app/pages/auth/Login";
import ResetPassword from "app/pages/auth/ResetPassword";
import React from "react";
import {Navigate, Route, Routes, useLocation} from "react-router-dom";
import Register from "app/pages/auth/Register";
import AuthLayout from "app/common/layout/AuthLayout";
import AcceptInvite from "app/pages/auth/AcceptInvite";

const NoAuthRoute = _ => {

    // Redirection after login
    const {pathname, search} = useLocation();
    let reDir = "/login" + ((sessionStorage.getItem("redirectToHome") || pathname === "/" || pathname === "/dashboard") ? "" : `?redirect_to=${encodeURIComponent(`${pathname}${search}`)}`);

    // All route require user NOT to be Authenticated

    return <AuthLayout> 
                <Routes>
                    <Route path="/reset-password" element={<ResetPassword/>} />
                    <Route path="/register" element={<Register/>} />
                    <Route path="/login" element={<Login/>} />
                    <Route path="/accept-invite" element={<AcceptInvite />} />
                    <Route path="*" element={<Navigate to={reDir} />} />
                </Routes>
            </AuthLayout>
}
export default NoAuthRoute;
